module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product3-8af8d8a410ff623106ec082264bec4bb.jpg";